export default function RoumaldEmphasis({ children }) {
  return <span className="font-roumald-bolditalic uppercase">{children}</span>;
}
